import React, { useState, useEffect, useRef, useCallback } from 'react';
import { API_URL } from '../config';

export default function JackpotBanner() {
  const [info, setInfo]       = useState(null);
  const [visible, setVisible] = useState(false);
  const timerRef              = useRef(null);
  const lastSeenRef           = useRef(localStorage.getItem('jackpot_seen') || '');

  const showBanner = useCallback((username, key) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setInfo({ username });
    setVisible(true);
    timerRef.current = setTimeout(() => setVisible(false), 5000);
    if (key) {
      lastSeenRef.current = key;
      localStorage.setItem('jackpot_seen', key);
    }
  }, []);

  // Jackpot local : le joueur connecte vient de gagner
  useEffect(() => {
    const onJackpot = (e) => showBanner(e.detail.username, null);
    window.addEventListener('jackpot-won', onJackpot);
    return () => window.removeEventListener('jackpot-won', onJackpot);
  }, [showBanner]);

  // Jackpot distant : poll toutes les 10s pour les autres joueurs
  useEffect(() => {
    const check = async () => {
      try {
        const r = await fetch(API_URL + '/games/jackpot-latest');
        const d = await r.json();
        if (!d.success || !d.jackpot) return;
        const key = d.jackpot.created_at;
        if (key === lastSeenRef.current) return;
        showBanner(d.jackpot.username, key);
      } catch (_) {}
    };
    check();
    const iv = setInterval(check, 10000);
    return () => {
      clearInterval(iv);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [showBanner]);

  if (!visible || !info) return null;

  return (
    <div className="jackpot-banner-bar" role="alert">
      <div className="jackpot-banner-marquee">
        <span>
          🎰 <strong>{info.username}</strong> vient de remporter le JACKPOT à la Roulette !&nbsp;&nbsp;&nbsp;🎉&nbsp;&nbsp;&nbsp;
          🎰 <strong>{info.username}</strong> vient de remporter le JACKPOT à la Roulette !&nbsp;&nbsp;&nbsp;🎉&nbsp;&nbsp;&nbsp;
          🎰 <strong>{info.username}</strong> vient de remporter le JACKPOT à la Roulette !&nbsp;&nbsp;&nbsp;🎉&nbsp;&nbsp;&nbsp;
        </span>
      </div>
    </div>
  );
}
